import { BarChart } from '@finect/tabular-icons/barChart';
import { TrendingUp } from '@finect/tabular-icons/trendingUp';
import { ETFs } from '@finect/tabular-icons/etfs';
import { DefaultIconCrypto, DefaultIconFund, DefaultIconBook, DefaultIconCard, DefaultIconCrowdfunding, DefaultIconDeposit, DefaultIconEstate, DefaultIconManagedAccount, DefaultIconNFT, DefaultIconPlan, DefaultIconProject, DefaultIconRoboadvisor, DefaultIconSavingsAccount, DefaultIconService, DefaultIconStock, DefaultIconToken, DefaultIconWallet, DefaultIconCourse, DefaultIcon } from '../Icon/partials';
export var PRODUCT_TYPES_WITH_ICON = {
  crypto: DefaultIconCrypto,
  fund: DefaultIconFund,
  'new-fund': TrendingUp,
  book: DefaultIconBook,
  card: DefaultIconCard,
  crowdfunding: DefaultIconCrowdfunding,
  deposit: DefaultIconDeposit,
  estate: DefaultIconEstate,
  managedaccount: DefaultIconManagedAccount,
  nft: DefaultIconNFT,
  plan: DefaultIconPlan,
  'new-plan': BarChart,
  ipo: DefaultIconPlan,
  project: DefaultIconProject,
  startup: DefaultIconProject,
  roboadvisor: DefaultIconRoboadvisor,
  savingsaccount: DefaultIconSavingsAccount,
  service: DefaultIconService,
  stock: DefaultIconStock,
  etf: DefaultIconStock,
  'new-etf': ETFs,
  token: DefaultIconToken,
  wallet: DefaultIconWallet,
  course: DefaultIconCourse,
  ppa: DefaultIcon,
  pias: DefaultIcon,
  unitlink: DefaultIcon,
  insurance: DefaultIcon,
  'inverst-service': DefaultIcon,
  'mortgage-service': DefaultIcon,
  sialp: DefaultIcon,
  'paid-account': DefaultIcon,
  'fiscal-service': DefaultIcon,
  'overnight-money': DefaultIcon,
  savingsinsurance: DefaultIcon,
  finect: DefaultIcon
};